#import "./defaultAvailabilityInfo.gql"

query GetDefaultAvailabilities {
  defaultAvailabilities {
    ...defaultAvailabilityInfo
  }
}

mutation UpdateDefaultAvailabilities($defaultAvailabilities: [DefaultAvailabilityInput!]!) {
  updateDefaultAvailabilities(defaultAvailabilities: $defaultAvailabilities) {
    defaultAvailabilities {
      ...defaultAvailabilityInfo
    }
  }
}
